import { ToastService } from "src/app/services/toast.service";
import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { StructureService } from "../../../services/structure.service";
import { DataService } from "../../../services/data.service";
import { LocalService } from "../../../services/local.service";
import { UrlService } from "../../../miscellaneous/url.service";
import { IFile } from "./interfaces/iFile";
import { isNullOrUndefined } from "../../../helpers/utils";
import { FormService } from "src/app/services/form.service";
import { ActivatedRoute } from "@angular/router";
import { Files } from "src/app/miscellaneous/files";
import { LocationStrategy } from "@angular/common";
import { HttpMethod } from "src/app/helpers/http-method.enum";
import { catchError, distinctUntilChanged, EMPTY, filter, from, map, Observable, of, switchMap, take, tap, throwError } from "rxjs";
import { UserPermissionService } from "src/app/services/permission.service";
import { environment } from "src/environments/environment";
import { ButtonType, ButtonTypeENUM } from '../../../helpers/button-type.enum';
import { MenuService } from "src/app/services/menu-service.service";
import { AuthService } from "src/app/services/auth.service";
import { SharedDataBridgeService } from "src/app/services/shared-data-bridge.service";
import { HttpClient } from "@angular/common/http";
import { ConfirmationDialogService } from "src/app/services/confirmation-dialog.service";
import { Router } from '@angular/router';

@Component({
  selector: "form-component",
  templateUrl: "./forms.component.html",
  styleUrls: ["./forms.component.scss"],
  providers: [UrlService],
})
export class FormComponent implements OnInit {
  @Input() jsonform!: [];
  @Input() props!: any;
  @Input() endpoint!: string;
  @Input() redirect!: string;
  @Input() model: any;
  static compName = "Form";
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  form: FormGroup = new FormGroup({});
  id: string | null | false = null;
  uploadProgress?: number;
  udm: any;
  loading: boolean = false;

  fields$: Observable<FormlyFieldConfig[]> = this.formService.fields$;

  showSaveButton: boolean = false;
  private associationOrderLoaded = false;

  constructor(
    private ssv: StructureService,
    private ds: DataService,
    private localStore: LocalService,
    private serviceUrl: UrlService,
    private toastService: ToastService,
    private formService: FormService,
    private route: ActivatedRoute,
    private files: Files,
    private location: LocationStrategy,
    private _permissionService: UserPermissionService,
    private menuService: MenuService,
    private authService: AuthService,
    private sharedDataBridge: SharedDataBridgeService,
    private http: HttpClient,
    public confirmationDialogService: ConfirmationDialogService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.formService.loading$.subscribe({
      next: (loading) => {
        this.loading = loading;
      },
    });


    if (this.props.type === 'is_filter' && this.props.comunicazione && this.endpoint) { // && this.props.comunicazione
      this.serviceUrl.getQueryParams().subscribe({
        next: (value) => {
          this.model = { ...this.model, ...value };
          const modelData = this.parseNumericValues(value)
          this.ds.setModelData(modelData)
        },
      });
      this.sharedDataBridge.setEndpoint(this.endpoint);
    }

    const state = this.location.getState() as { data?: any };

    if (state?.data) {
      this.model = state?.data;
    }

    if (!this.model) this.model = Object.create({});

    this.id = this.serviceUrl.getUrlId(this.props["page"]);

    if (this.id) {
      this.model.id = this.id;
    }

    if (this.id && (isNullOrUndefined(this.props["loadData"]) || this.props["loadData"] === true)) this.loadData();
    this.checkInterceptor();

    this.fields = this.jsonform;
    this.formService.setFields(this.fields);

    setTimeout(() => {
      this.formService.setFormData(this.form);
      this.formService.formData$.subscribe((data) => {
        if (data) {
          this.form = data;
        }
      });
    }, 100);


    if (this.props.type === "is_filter" || !this.authService.isAdminUrl()) {
      this.showSaveButton = true;
      return;
    }

    this.checkShowSaveButton();

  }

  parseNumericValues(obj: Record<string, any>): Record<string, any> {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => {
        const parsedValue = typeof value === 'string' && !isNaN(Number(value))
          ? Number(value)
          : value;
        return [key, parsedValue];
      })
    );
  }

  checkShowSaveButton(): void {
    if (environment.allowPermissions) {
      this.showSaveButton = true;
      return;
    }

    from(this.authService.getRole()).pipe(
      switchMap((role) => {
        if (role === 'admin') {
          this.showSaveButton = true;
          return EMPTY;
        }

        return this.menuService.menuItem$.pipe(
          filter((item) => !!item),
          switchMap((item) =>
            this._permissionService.loadCheckPermission(
              item?.entityType,
              !this.model.id ? ButtonTypeENUM.INSERT : ButtonTypeENUM.UPDATE
            ).pipe(
              tap((hasPermission: boolean) => {
                if (hasPermission) {
                  this.showSaveButton = true;
                }
              })
            )
          )
        );
      })
    ).subscribe();
  }

  onClickButton() {
    this.confirmationDialogService.showConfirmModal({
      title: "Cancella",
      message: "Sicuro di voler cancellare tutti i files?",
      confirmButtonLabel: "Conferma",
      cancelButtonLabel: "Annulla",
    }).pipe(
      filter(Boolean),
      tap(() => {
        this.ds.addData(this.model, this.props.endpointButtom).subscribe(() => {
          if (this.redirect) {
            this.serviceUrl.goToPage("/" + this.redirect);
          } else {
            window.location.reload();
          }
        });
      })
    ).subscribe();
  }

  onSubmit(model: any) {

    this.ds.setModelData(model);

    let check = true;
    let endpoint = this.endpoint;

    if (this.form.valid && check) {

      if (this.props.type === "is_filter") {
        // this.ssv.addData(model, this.endpoint);
        this.ssv.isFilterEventEmitter.emit({ model: model, endpoint: this.endpoint });
      } else if (this.props.type === "interceptor") {
        this.setLocalStorage(model);
      } else if (this.props.type === "file") {
        if (this.model.associaFiles && this.model.associaFiles.length > 0) {
          this.associaFile();
        } else if (this.model.file && this.model.file.length > 0) {
          this.sendFile();
        } if (this.model.id && (!this.model.file || this.model.file.length === 0)) { // Caso update senza file
          const formData: FormData = new FormData();
          formData.set("allegato", JSON.stringify(this.model));

          this.updateFile(this.endpoint, formData);
        }
      } else if (this.props.type === 'calcoli') {
        this.getCalcoli(model);
        this.loading = false;
      } else {
        if (this.id !== null && this.id !== false) {
          // Effettua un aggiornamento
          this.ds
            .putData(model, endpoint + "/" + this.id)
            .subscribe(() => {
              if (this.redirect) {
                this.serviceUrl.goToPage("/" + this.redirect);
              } else {
                window.location.reload();
              }
            });
          return;
        } else if (this.endpoint) {
          // Effettua inserimento
          this.ds.addData(model, this.endpoint).subscribe(() => {
            if (this.redirect) {
              this.serviceUrl.goToPage("/" + this.redirect);
            } else {
              window.location.reload();
            }
          });
          return;
        } else if (model.typeReport) {
          const { method, url, name } = model.typeReport;

          switch (method) {
            case HttpMethod.GET:
              this.files.download(url, -1, name);
              break;
            case HttpMethod.POST:
              this.ds.addData(model, url).subscribe((resp) => this.files.downloadFile(resp, name));
              break;
            default:
              console.warn("Unsupported HTTP method:", method);
          }
        }
      }
    }
  }

  /**
   * Recupera la configurazione dei vocabolari e li aggiunge al form.
   */
  loadVocabulariesConfig(): void {
    const vocabulariesConfig = this.props["vocabularies"];
    const configEndpoint = vocabulariesConfig?.vocabulariesEndpoint;

    this.ds
      .getData(configEndpoint)
      .pipe(
        take(1),
        tap((data: any[]) => {
          const parentFormKey = vocabulariesConfig?.parentFormKey;
          const newFields = data.map((item: { [key: string]: any }) => {
            return {
              key: item[vocabulariesConfig?.nameKey],
              type: "ngselect",
              className: vocabulariesConfig?.class,
              props: {
                placeholder: item[vocabulariesConfig?.placeholderKey],
                label: item[vocabulariesConfig?.placeholderKey],
                multiple: vocabulariesConfig?.multiple,
                endpoint: `${vocabulariesConfig.categoriesEndpoint}/${item["id"]}`,
                valueProp: vocabulariesConfig?.valueKey,
                labelProp: vocabulariesConfig?.labelKey,
                clearable: vocabulariesConfig?.clearable,
              },
            };
          });

          this.addToForm(newFields, parentFormKey);
        })
      )
      .subscribe();
  }

  /**
   *
   * @param selectFields
   * @param findedFormlyForm
   * Aggiunge i campi al form selezionato
   */
  addToForm(newFields: FormlyFieldConfig[], parentFormKey: string): void {
    const findFormByKey = this.fields.find((field: FormlyFieldConfig) =>
      field.props ? field.props["formKey"] === parentFormKey : null
    );

    // Se trova il form aggiunge i campi al fieldGroup
    if (findFormByKey) {
      findFormByKey!.fieldGroup = [...(findFormByKey!.fieldGroup || []), ...newFields];
      this.fields = [...this.fields];
    } else {
      // Se non trova il form aggiunge i campi al form principale
      this.fields = [...this.fields, ...newFields];
    }
  }

  sendFile() {

    const isMultipleFiles = this.props["multipleUpload"];

    if (isMultipleFiles) {
      this.uploadMultipleFiles();
      return;
    }

    const files: File[] = this.model.file;

    Array.from(files).forEach((file) => {
      const formData: FormData = new FormData();

      const obj: IFile = {
        title: this.model.title ?? file.name,
        slug: this.slugify(file.name),
        fileName: file.name,
        mimeType: file.type,
        extension: file.name.split(".").pop() ?? "",
        statusId: this.model.statusId ?? 1,
        path: new Date().getFullYear().toString(),
      };

      // Recuperiamo la proprietà dinamicamente che ha una struttura tipo { "5_<entity_type>": [59], "7_<entity_type>": [7] }
      const findKeyByPattern = (obj: any, pattern: RegExp): [string, any] | undefined => {
        if (typeof obj === "object" && obj !== null) {
          // Esplora tutte le chiavi nell'oggetto principale
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              console.log(`Verifica chiave: ${key}`); // Log per debug
              // Se troviamo una chiave che è un oggetto e che contiene chiavi che corrispondono al pattern
              if (typeof obj[key] === "object" && obj[key] !== null) {
                const subKeys = Object.keys(obj[key]);
                // Controlliamo se una delle chiavi dell'oggetto annidato corrisponde al pattern
                const matchingSubKey = subKeys.find((subKey) => pattern.test(subKey));
                if (matchingSubKey) {
                  // Restituiamo la chiave principale (come "vocabularies") e tutto il suo valore
                  return [key, obj[key]];
                }
              }
            }
          }
        }
        return undefined;
      };

      const result = findKeyByPattern(this.model, /^[0-9]+./);

      if (result) {
        obj[result[0]] = result[1];
      }

      obj.type = this.model.type ?? 1;
      obj.hits = 0;

      formData.set("file", file);

      if (!this.model.title || (this.model.title && !this.model.id)) {
        formData.set("allegato", JSON.stringify(obj));
        const fieldsFormsData = this.props["fieldsFormsData"] as string[];
        fieldsFormsData?.forEach(f => formData.set(f, this.model[f]))
        this.uploadFile(formData);
      } else {
        this.model.fileName = null;
        formData.set("allegato", JSON.stringify(this.model));
        this.updateFile(this.endpoint, formData);
      }
    });
  }

  private uploadMultipleFiles(): void {

    const formData: FormData = new FormData();

    Object.values(this.model.file).forEach((file) => formData.append("files", file as File));

    this.uploadFiles(formData, (response: any) => {

      if (response.status == 200) {
        this.toastService.show({
          template: 'success',
          classname: 'bg-success text-light',
          message: response.body,
        });
        setTimeout(() => window.location.reload(), 2000);
        return;
      }

      if (response.status == 206) {
        this.toastService.show({
          template: 'info',
          classname: 'bg-warning text-dark',
          message: response.body,
          type: "warning"
        });
        setTimeout(() => window.location.reload(), 2000);
        return;
      }

      this.toastService.show({
        template: 'dangerTpl',
        classname: 'bg-danger text-light',
        error: response.status,
        message: response.error || 'Errore durante il caricamento',
      });

    });

  }

  associaFile(): void {
    this.model.associaFiles.forEach((idFile: any) => {
      const endpoint = `${this.endpoint}/${this.id}/${idFile}`;
      this.ds.associaFile(endpoint, this.model).subscribe(() => {
        if (this.redirect) {
          this.serviceUrl.goToPage("/" + this.redirect);
        } else {
          window.location.reload();
        }
      });
    });
  }

  // sendFile(model: any) {

  //   if (model.associaFiles && model.associaFiles.length > 0) {
  //     model.associaFiles.forEach((idFile: any) => {
  //       this.ds.addData(
  //         {
  //           "fileableType": model.obType,
  //           "fileableId": this.id
  //         }, this.endpoint + "/" + idFile).subscribe();
  //     })

  //     window.location.reload();

  //   }

  //   const formData: FormData = new FormData();

  //   if (model.file && model.file.length > 0) {
  //     const files: File[] = model.file
  //     Array.from(files).forEach(file => {

  //       let obj: IFile = {
  //         title: model.title ?? file.name,
  //         slug: this.slugify(file.name),
  //         fileName: file.name,
  //         mimeType: file.type,
  //         extension: file.name.split('.').pop() ?? '',
  //         statusId: model.statusId ?? 1,
  //         path: new Date().getFullYear().toString()
  //       };
  //       obj.type = model.type ?? 1;
  //       obj.hits = 0;

  //       if (model.obType) {
  //         obj.fileableType = model.obType;
  //         obj.fileableId = this.id;
  //       }
  //       formData.append("allegato", JSON.stringify(obj));
  //       formData.append("file", file);

  //     })
  //   }
  //   // aggiornamento del model da document (con file e senza file)
  //   // insereti title perchè ora id è sempre presente
  //   if (model.id && model.title) {
  //     if (!formData.has("allegato")) formData.append("allegato", JSON.stringify(model));
  //     this.updateFile(this.endpoint + "/" + model.id, formData)
  //   } else if (formData.has("allegato")) {
  //     this.uploadFile(formData);
  //   }

  // }

  private uploadFiles(formData: FormData, onComplete?: (response: any) => void) {
    const uploadFileEndpoint = `${this.endpoint}${this.id ? `/${this.id}` : ''}`;
    return this.http.post<any>(environment.api_base_url + uploadFileEndpoint, formData, {
      observe: 'response',
      responseType: 'text' as 'json'
    }).subscribe({
      next: (response: any) => {
        if (onComplete)
          onComplete(response);
      },
      error: (response: any) => {
        if (onComplete)
          onComplete(response);
      }
    })
  }

  private uploadFile(formData: FormData) {
    //const uploadFileEndpoint = `${this.endpoint}/${this.id}`;
    const uploadFileEndpoint = `${this.endpoint}${this.id ? `/${this.id}` : ''}`;

    this.ds.uploadFile(uploadFileEndpoint, formData).subscribe((progress) => {
      this.uploadProgress = progress;
      if (progress === 100) {
        // alert("File upload completed")
        // File upload completed
        this.uploadProgress = 0;
        // this.ssv.setData(this.endpoint);

        if (this.redirect) {
          this.serviceUrl.goToPage("/" + this.redirect);
        } else {
          // window.location.reload();

          const currentUrl = this.router.url;
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
      }
    });
  }

private updateFile(endpoint: string, formData: FormData) {
  const url = this.model.id
    ? endpoint + '/' + this.model.id
    : endpoint;

  this.ds
    .updateFile(url, formData)
    .pipe(
      filter((progress) => progress === 100),
      take(1),
      switchMap(() => this.updateAssociationOrder())
    )
    .subscribe({
      next: () => {
        this.uploadProgress = 0;
        if (this.redirect) {
          this.serviceUrl.goToPage("/" + this.redirect);
        } else {
          this.location.back();
        }
      },
      error: (error) => {
        this.uploadProgress = 0;

        console.error(
          "Errore nel salvataggio dell'ordine di estrazione:",
          error
        );
      }
    });
  }

  private slugify(str: string) {
    return String(str)
      .normalize("NFKD") // divide i caratteri accentati nei caratteri base e nei segni diacritici
      .replace(/[\u0300-\u036f]/g, "") // rimuove tutti gli accenti, che si trovano nel blocco \u03xx UNICODE.
      .trim() // taglie gli spazi bianchi iniziali o finali
      .toLowerCase() // converte in minuscolo
      .replace(/[^a-z0-9 -]/g, "") // rimuove i caratteri non alfanumerici
      .replace(/\s+/g, "-") // sostituisce gli spazi con i trattini
      .replace(/-+/g, "-"); // rimuove i trattini consecutivi
  }

  mapFields(fields: FormlyFieldConfig[]) {
    return fields.map((f) => {
      if (f.fieldGroup && f.fieldGroup.length > 0) {
        this.mapFields(f.fieldGroup);
      }
      /*
      if(f.key==='modalOpener') {
        nf.props = {
          ...(f.props || {}),
          onClick: ($event: ay) => { this.modal.hide = !this.modal.hide; }
        }
      }
      */
      return f;
    });
  }

  methodToCall: string = "";

  loadData() {
    const endpoint = this.props["loadDataFrom"]
      ? this.props["loadDataFrom"]
      : this.endpoint;

    this.associationOrderLoaded = false;

    this.ds
      .getData(endpoint + "/" + this.id)
      .pipe(
        switchMap((model) => this.loadAssociationOrder(model))
      )
      .subscribe((model) => {
        this.model = model;
        this.ds.setModelData(model);
      });
  }

  private getAssociationOrderConfig(): any | null {
    return this.props?.["associationOrder"] ?? null;
  }

  private getAssociationOrderEndpoint(
    fileId: string | number | null | undefined
  ): string | null {

    const config = this.getAssociationOrderConfig();

    if (
      !config?.entityType ||
      fileId === null ||
      fileId === undefined
    ) {
      return null;
    }

    const storageKey =
      config.entityIdSessionStorageKey ?? "idObbligo";

    const entityId = sessionStorage.getItem(storageKey);

    if (!entityId) {
      return null;
    }

    return `/associable/files/${config.entityType}/${entityId}/${fileId}`;
  }

  private loadAssociationOrder(model: any): Observable<any> {

    const associationEndpoint =
      this.getAssociationOrderEndpoint(model?.id);

    if (!associationEndpoint) {
      return of(model);
    }

    return this.ds
      .getData(associationEndpoint)
      .pipe(
        map((association: any) => {

          this.associationOrderLoaded = true;

          return {
            ...model,
            ordineEstrazione:
              association?.ordineEstrazione ?? null
          };
        }),
        catchError((error) => {

          this.associationOrderLoaded = false;

          console.error(
            "Errore nel recupero dell'ordine di estrazione:",
            error
          );

          return of(model);
        })
      );
  }

  private updateAssociationOrder(): Observable<any> {

    const associationEndpoint =
      this.getAssociationOrderEndpoint(this.model?.id);

    if (
      !associationEndpoint ||
      !this.associationOrderLoaded
    ) {
      return of(null);
    }

    const rawValue = this.model.ordineEstrazione;

    const ordineEstrazione =
      rawValue === "" ||
      rawValue === null ||
      rawValue === undefined
        ? null
        : Number(rawValue);

    if (
      ordineEstrazione !== null &&
      Number.isNaN(ordineEstrazione)
    ) {
      return throwError(
        () => new Error("La Posizione deve essere un numero.")
      );
    }

    return this.ds.patchData(
      { ordineEstrazione },
      associationEndpoint
    );
  }

  checkInterceptor() {
    if (this.props.type === "interceptor") {
      let model: any = {};
      Object.keys(localStorage).forEach((key) => {
        if (key.includes("interceptor")) {
          const value = this.localStore.getData(key);
          const originalKey = key.replace(/interceptor./g, "");
          model[originalKey] = isNaN(Number(value)) ? value : Number(value);
        }
        this.model = model;
        this.ds.setModelData(model);
      });
    }
  }

  setLocalStorage(model: any) {
    this.localStore.setAllKeys(model);
    this.toastService.show({
      template: "success",
      classname: "bg-success text-light",
      delay: 3000,
      message: "Salvataggio effettuato correttamente",
    });
  }



  getCalcoli(model: any) {
    this.formService.setLoadingState(true);
    this.formService.setDataTable([])
    if (model && model["calcoloType"]) {
      this.ds.getData(this.endpoint).subscribe({
        next: () => {
          this.updateTableDataCalcoli(model);
        }, error: (error) => {
          console.error(error);
          this.loading = false;
          this.formService.setLoadingState(false);
        }, complete: () => {
          this.loading = false;
          this.formService.setLoadingState(false);
        }
      });
    }
    this.loading = false;
  }

  showAwaitToast() {
    this.toastService.show({ template: 'info', classname: 'bg-warning text-dark', delay: 5000, message: 'Attenzione, l\'operazione può richiedere qualche secondo', header: 'Calcolo in corso', type: "warning" });
  }

  updateTableDataCalcoli(model: any) {
    if (model) {
      this.ds.getDataByURL("/logEsecuzione", model["calcoloType"]).subscribe(obj => {
        this.formService.setLoadingState(false);
        this.formService.setDataTable(obj);
      });
    }
    //this.loading.next(false);
  }

}
